import styles from './index.module.sass'

interface Props {
    icon: string
    size?: number | string
    width?: number | string
    height?: number | string
    color?: string
}

export const Icon = ({ icon, height, width, size = 70, color }: Props) => {
    const iconWith = width ?? size
    const iconHeight = height ?? size
    return (
        <svg
            style={{
                width: iconWith + '%',
                height: iconHeight + '%',
                fill: color,
            }}>
            <use xlinkHref={`/sprite.svg#${icon}`}></use>
        </svg>
    )
}
